//import { GHOST_MODE_TYPE_MERCHANT as GHOST_MERCHANT } from '../../constants/modes';
import {
  MERCHANT_CHECKOUT_TYPE_STANDARD,
  MERCHANT_CHECKOUT_TYPE_FEE,
  PROCESSORS_ACH,
  PROCESSORS,
  PROCESSOR_PSP
} from '../../constants';

const isShowMenu = (featureChecker) => {
  const isShow = ({ context, params }) => {
    if (!context || !params) return false;

    const { id } = params;
    const {
      global: { data = {} } = {},
      editor: { selectedAccount: { _id: merchantId } = {} } = {}
    } = context;
    const { type: ghostType } = data.ghost || {};
    const { merchants = [] } = (data.profile && data.profile) || {};
    const merchant = merchants.find((item) => item.id === merchantId) || {};
    const relations = {
      //'event-logs': ghostType !== GHOST_MERCHANT,
      default: ghostType || merchants.length > 0
    };
    const validByRelations =
      typeof relations[id] !== 'undefined' ? relations[id] : relations.default;

    return validByRelations && (!featureChecker || featureChecker(merchant, merchants));
  };
  isShow.featureChecker = featureChecker;

  return isShow;
};

export default isShowMenu;

export const getActivateAppUrl = ({ context }) => {
  const {
    editor: { selectedAccount: { id } = {} }
  } = context;
  if (!id) return '/';

  return `/applications/${id}`;
};

export const isShowCheckout = ({ context }) => {
  const {
    editor: {
      selectedAccount: {
        processor,
        settings: {
          checkout: { chargeType } = {},
          processors: settingsProcessors = {},
          processors: { FDC: { datawireId } = {} } = {}
        } = {},
        giftCardProcessor: { processor: gfProcessor } = {}
      } = {}
    } = {}
  } = context;
  const {
    global: { data = {} } = {},
    editor: { selectedAccount: { _id: merchantId } = {} } = {}
  } = context;
  const { merchants = [] } = (data.profile && data.profile) || {};
  const merchant = merchants.find((item) => item.id === merchantId) || {};
  const { userAccessScopes: { 'checkout-form': checkoutForm } = {} } = merchant;
  const excludeNotAch = (procName) => PROCESSORS_ACH.includes(PROCESSORS[procName]);
  const achProcName = Object.keys(settingsProcessors || {})
    .filter(excludeNotAch)
    .shift();

  return (
    checkoutForm &&
    [MERCHANT_CHECKOUT_TYPE_STANDARD, MERCHANT_CHECKOUT_TYPE_FEE].includes(chargeType) &&
    (datawireId || achProcName || gfProcessor || String(processor) === PROCESSOR_PSP)
  );
};
